<template>
<a class="arrow-button" :class="colorClass ? colorClass : 'white-arrow'" :href="linkData?.src || linkData"
    :title="linkData?.name || title" target="_blank">
</a>
</template>

<script>
export default {
    name: 'ArrowButton',
    props: {
        linkData: Object || String,
        colorClass: String,
        title: {
            type: String,
            default: ''
        }
    },
}
</script>